module.exports = __webpack_public_path__ + "img/reset-step-three2.98eb4939.png";